/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { easyPost } from './utils';

//  配置
export const getCommonConfig = easyPost('user.banner.config');

//  卡套餐
export const getBikeTaoCan = easyPost(
  'user.bike.ridecard.standard.package',
  // { api: 'https://yapi.hellobike.cn/mock/3191/85919' }
  { api: config.BIKE_API, risk: true },
);

//  营销分发接口
export const marketDistribute = easyPost('activity.dispatcher.distribute', {
  api: config.MARKET_API,
  risk: true,
});


//  单车预下单
export const bikeCardPreOrder = easyPost(
  'bike.trade.preOrderV2',
  { api: config.BIKE_API, risk: true },
);

// 两轮商品预下单
export const twPreOrder = easyPost(
  'tw.standard.preOrder',
  { api: config.BIKE_API, risk: true },
);

//  批量报名活动
export const enrollActicity = easyPost('marketing.promoactivity.batchApplyActivity');

//  获取活动状态和用户参与记录
export const getUserAndActivityInfo = easyPost('marketing.promoactivity.batchQueryUserActivityStatus');

// 兑换商品列表
export const getRotationList = easyPost('rotation.list', {
  api: config.MARKET_API,
});

export const getCardPageModule = easyPost('common.module.data', {});

export const getAPPCoupons = easyPost('market.coupon.module');

export const getTWCards = easyPost('tw.ridecard.commodity', { api: config.BIKE_API, risk: true });

export const getSign = easyPost('wechat.sa.sign', { api: 'https://api.hellobike.com/api' });

export const getWechatScanCards = easyPost('wechatScan.bike.prize');

// 获取情景弹窗数据
export const getEmotion = easyPost('user.platform.emotion');

// 整合营销页3期接口
export const getCardList = easyPost('common.welfare.arrgdata');

/**
 * 用户维度业务场景校验 (校验是否需要展示购卡协议)
 */
export const getUserDimension = easyPost('tw.card.biz.scene.check', {
  api: config.BIKE_API,
});
